<template>
	<div>
		<!-- 选择成员操作 -->
		<!--  -->
		<el-dialog :show-close="show_closer" :title="dialogname" :visible.sync="show" :append-to-body="true" 
			:close-on-click-modal="close_modal" :close-on-press-escape="close_press" width="500px"
			:lock-scroll="lock_scrol" :before-close="handleClose" >


			<div class="pro_top FlexRow">

				<!--  -->
				<div class="searchinput">
					<el-input clearable @keyup.enter.native="fn_get_membelist" placeholder="成员名称/手机号码" v-model="search_name"
						class="search_input">
					</el-input>
					<div class="icons" @click="fn_get_membelist">
						<i class="el-icon-search"></i>
					</div>
				</div>
				<!--  -->
			</div>

			<div class="pro_content scrolbox">
				<div class="pro_item" v-for="(item, index) in memberlist" @click="selectp_change(index)">
					<div class="check_boxs FlexRow " v-show="!item.checked">
						<i class="el-icon-check"></i>
					</div>
					<div class="check_boxs FlexRow isActive" v-show="item.checked">
						<i class="el-icon-check"></i>
					</div>
					<div class="img_box"> 
						<el-image fit="cover" :src="item.head_image" lazy v-if="item.head_image"></el-image>
						<img src="~assets/img/def_icon.png" v-else>
					</div>
					<div class="pro_info">
						<div class="pro_name">
							{{item.name || ''}}
						</div>
						<div class="pro_jiage">
							{{item.user_name || ''}}
						</div>
					</div>
				</div>
			</div>
			<div class="dialog-footer" slot="footer">
				<el-button class="b" @click="handleClose">取消</el-button>
				<el-button class="b save comkl" @click="pro_comkl">确定</el-button>
			</div>
		</el-dialog>
		<!--  -->




	</div>
</template>

<script>
	var that;
	import {
		handlereq,
		alertMess,
	} from 'network/kh_public'

	import {		
		get_membelist,
	} from 'network/hk_operset'
	export default {
		name: "collaborator",
		props: {
			// 是否显示弹窗
			show: {
				type: Boolean,
				default: false,
			},
			// 操作类型 ： 1，单选； 2 多选
			types: {
				type: Number,
				default: 1,
			},
			// 选中的成员列表 id [1,2,3]
			checklist: {
				type: Array,
				default:  ()=>{
					return []
				},
			},
			
			// 是否显示关闭按钮
			show_closer: {
				type: Boolean,
				default: true,
			},
			// 是否可以通过点击 modal 遮罩层 关闭 Dialog
			close_modal: {
				type: Boolean,
				default: false,
			},
			// 是否可以通过按下 ESC 关闭 Dialog
			close_press: {
				type: Boolean,
				default: true,
			},
			// 是否在 Dialog 出现时将 body 滚动锁定 
			lock_scrol: {
				type: Boolean,
				default: false,
			},
			
			// 
			dialogname: {
				type: String,
				default: '转让',
			},
			
			
		},

		watch: {
			show() {
				if(this.show) {
					this.fn_get_membelist()
				}
				else {
					this.search_name = ''
					this.memberlist = []
				}
			},
			
		},
		data() {
			return {
				//
				memberlist: [],
				search_name: '',
				// 
			}
		},

		created() {
			that = this
			
		},
		methods: {
			
			// 添加协作人 
			pro_comkl() {
				let arr = this.memberlist.filter(v => v.checked)
				if (arr.length) {
					let res = {
						types: this.types,  // 类型
					}
					if(this.types == 1) {  // 单选
						res.member_id = arr[0].member_id ? arr[0].member_id : '';  // 单个成员id
					}
					else if(this.types == 2) {  // 多选
						let newArr = []
						for (let item of arr) {
							if (item.member_id) {
								newArr.push(item.member_id)
							}
						}
						res.member_arr = newArr
					}
					this.$emit('success', res)
				}
				else {
					alertMess('请选择成员', 'error')
				}
			},
			// 点击选择协同人
			selectp_change(index) {
				if(this.types == 1) {  // 单选
					for(let item of this.memberlist) {
						item.checked = false
					}
				}
				let obj = this.memberlist[index]
				obj.checked = !obj.checked
			},
			// 获取协同人 成员列表
			fn_get_membelist() {
				let search = (this.search_name + '').trim() || '';
				get_membelist(search).then(res => {
					if (handlereq(res)) {
						let obj = res.result.data
						for (let item of obj) {
							item.checked = false
						}
						// 已选中的成员 勾选
						if(this.checklist.length) {  // 【1,2,3】
							for(let item of this.checklist) {
								if(item) {
									let index = obj.findIndex(v=>v.member_id == item)
									if(index != -1) {
										obj[index].checked = true
									}
								}
							}
						}
						this.memberlist = obj
					}
				})
			},
			
			
			// 弹出  点击遮罩和 x 关闭弹出
			handleClose(done) {
				this.$emit('update:show', false)
			},
		}
	}
</script>

<style scoped lang="scss">
	.comkl{
		background-color: #2a75ea !important;
		color:#fff !important;
	}
	.pro_top {
		width: 100%;
		margin-bottom: 10px;

		.searchinput {
			flex: 1;
			width: 100%;
			display: flex;
			align-items: center;
			position: relative;

			.icons {
				right: 35px;
				position: absolute;
				cursor: pointer;

				i {
					color: #ccc;
					font-size: 16px;
				}
			}
		}
	}

	.pro_content {
		max-height: 500px;
		overflow: auto;
		width: 100%;
		padding: 20px 0;

		.pro_item {
			display: flex;
			align-items: center;
			width: 100%;
			padding: 10px 0;
			position: relative;

			.check_boxs.isActive {
				background: rgba(42, 117, 234, 1);
				border: none;
			}

			.check_boxs {
				border: solid 1px #ccc;
				margin-right: 21px;
				cursor: pointer;
				border-radius: 100%;
				width: 21px;
				height: 21px;
				overflow: hidden;
				background: #fff;

				i {
					font-size: 14px;
					color: #fff;
				}
			}

			.img_box {
				width: 67px;
				height: 67px;
				border-radius: 5px;
				overflow: hidden;
				border: solid 1px #Eee;
				.el-image{
					width: 100%;
					height: 100%;
				}
				img {
					width: 100%;
					height: 100%;
					display: block;
				}
			}

			.pro_info {
				padding-left: 20px;
				flex: 1;
				height: 67px;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.pro_name {
					font-size: 14px;
					color: rgba(56, 56, 56, 1);
				}

				.pro_jiage {
					display: flex;
					align-items: center;
					justify-content: flex-start;

					font-size: 14px;
					color: rgba(128, 128, 128, 1);

				}
			}

		}
	}
</style>
